import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { AppState } from 'src/app/store/app.states';
import { ComponentBase } from 'src/app/views/component-base';
import { initialData_DataSaved, initialData_Form } from './selectors';
import { InitialDataModel } from './state';
import { FormGroupState, MarkAsTouchedAction, NgrxFormsModule } from 'ngrx-forms';
import { AppButtonComponent, EntryFieldComponent, Helper } from '@ifaa-components/ui-components';
import { CreateLeadRequestAction, ResetDataSavedAction } from './actions';
import { AsyncPipe, NgIf } from '@angular/common';
import { commonState_IsSending, commonState_LatestJourney } from 'src/app/store/common/common.selectors';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoToStepAction } from '../../actions';
import { SetDataFromInitialDataStepAction } from '../nmj-details/actions';
import { AppButtonDirective } from 'src/app/directives/appbutton.directive';

declare var grecaptcha: any;

@Component({
    selector: 'app-nmj-initial-data',
    templateUrl: './nmj-initial-data.component.html',
    styleUrls: ['./nmj-initial-data.component.scss'],
    imports: [AsyncPipe, AppButtonComponent, EntryFieldComponent, NgIf, NgrxFormsModule, ReactiveFormsModule, FormsModule, AppButtonDirective],
})
export class NmjInitialDataComponent extends ComponentBase implements OnInit, OnDestroy {

    @Input() set step(value: number) {
        this.stepIndex = value;
    }

    form$ = this.store.pipe(select(initialData_Form));
    isLoading$ = this.store.pipe(select(commonState_IsSending));
    journeySteps$ = this.store.pipe(select(commonState_LatestJourney));
    dataSaved$ = this.store.pipe(select(initialData_DataSaved));

    helper: Helper = new Helper();
    stepIndex: number = 0;
    nextStep: number = 0;

    constructor(public store: Store<AppState>) {
        super();
    }

    ngOnInit() {
        super.ngOnInitBase();

        this.sub = this.journeySteps$.subscribe(async x => {
            if (x) {
                this.nextStep = (await this.helper.getValue(this.journeySteps$)).journeySteps.filter(x => x.journeyStep > this.stepIndex)[0]?.journeyStep ?? -1;
            }
        })

        this.sub = this.dataSaved$.subscribe(async x => {
            if (x) {
                var data = (await this.helper.getValue(this.form$)).value;

                // set data for next step
                this.store.dispatch(SetDataFromInitialDataStepAction({ data }));

                // go next step
                this.store.dispatch(GoToStepAction({ index: this.nextStep }));

                // reset data saved prop
                this.store.dispatch(ResetDataSavedAction());
            }
        })
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }


    async onCreateLeadClick(form: FormGroupState<InitialDataModel>) {
        var journeySteps = await this.helper.getValue(this.journeySteps$);
        var journeyId = journeySteps.journeySteps[0].journeyId;

        if (form.isInvalid) {
            this.store.dispatch(new MarkAsTouchedAction(form.id));
            return;
        }
        if (grecaptcha) {
            grecaptcha
                .execute('6LfeW9saAAAAAPWtOiD0ly77pxy3mxibLWJd2-yH', {
                    action: 'submit',
                })
                .then((token) => {
                    var clone = this.helper.clone(form.value);
                    clone.token = token;
                    clone.journeyId = journeyId;
                    this.store.dispatch(CreateLeadRequestAction({ data: clone }));
                });
        } else {
            this.store.dispatch(CreateLeadRequestAction({
                data: {
                    ...form.value,
                    journeyId
                }
            }));
        }
    }
}
